import React from "react";
import styles from './PrivacyPolicy.module.css';

const PrivacyPolicy = () => {
  return (
    <div className={styles.container}>
      <div className={styles.privacyPolicyContainer}>
        <h1 className={styles.privacyPolicyTitle}>Política de Privacidad</h1>
        <p className={styles.privacyPolicyParagraph}>
          <strong>Última actualización:</strong> 01/09/2024
        </p>
        <h2 className={styles.privacyPolicySubTitle}>1. Introducción</h2>
        <p className={styles.privacyPolicyParagraph}>
          En <strong>BonFer Tech S.L</strong>, nos comprometemos a proteger la privacidad y la seguridad de nuestros usuarios. Esta política de privacidad describe cómo recopilamos, usamos y protegemos la información personal que nos proporcionas a través de nuestro sitio web www.bonfertech.com (en adelante, "el Sitio").
        </p>
        
        <h2 className={styles.privacyPolicySubTitle}>2. Información que Recopilamos</h2>
        <p className={styles.privacyPolicyParagraph}>
          Podemos recopilar los siguientes tipos de información personal cuando interactúas con nuestro sitio:
        </p>
        <ul className={styles.privacyPolicyList}>
          <li><strong>Información de contacto:</strong> como tu nombre, dirección de correo electrónico, número de teléfono, etc.</li>
          <li><strong>Información de navegación:</strong> detalles sobre tu visita a nuestro sitio, incluidas las páginas que visitas, el tiempo que pasas en el sitio, y la dirección IP de tu dispositivo.</li>
          <li><strong>Información de cookies:</strong> utilizamos cookies para mejorar tu experiencia en nuestro sitio, como recordar tus preferencias o analizar el uso del sitio.</li>
        </ul>
        
        <h2 className={styles.privacyPolicySubTitle}>3. Uso de la Información</h2>
        <p className={styles.privacyPolicyParagraph}>
          Utilizamos la información que recopilamos para los siguientes propósitos:
        </p>
        <ul className={styles.privacyPolicyList}>
          <li><strong>Proporcionar y mejorar nuestros servicios.</strong></li>
          <li><strong>Comunicarnos contigo para responder a tus preguntas o solicitudes.</strong></li>
          <li><strong>Enviar actualizaciones, ofertas especiales, o información que creemos que puede ser de tu interés</strong> (con tu consentimiento, si es necesario).</li>
          <li><strong>Analizar el uso del sitio para mejorar nuestra oferta.</strong></li>
        </ul>
        
        <h2 className={styles.privacyPolicySubTitle}>4. Compartir la Información</h2>
        <p className={styles.privacyPolicyParagraph}>
          No compartimos tu información personal con terceros, excepto en los siguientes casos:
        </p>
        <ul className={styles.privacyPolicyList}>
          <li><strong>Con proveedores de servicios</strong> que nos ayudan a operar el sitio y llevar a cabo nuestras actividades.</li>
          <li><strong>Cuando lo exige la ley</strong> o para proteger nuestros derechos legales.</li>
          <li><strong>En caso de venta o fusión de la empresa</strong>, tu información puede ser transferida al nuevo propietario.</li>
        </ul>
        
        <h2 className={styles.privacyPolicySubTitle}>5. Seguridad de la Información</h2>
        <p className={styles.privacyPolicyParagraph}>
          Implementamos medidas de seguridad adecuadas para proteger tu información personal contra el acceso no autorizado, la alteración, divulgación o destrucción. Sin embargo, ten en cuenta que ningún método de transmisión por Internet o almacenamiento electrónico es completamente seguro.
        </p>
        
        <h2 className={styles.privacyPolicySubTitle}>6. Tus Derechos</h2>
        <p className={styles.privacyPolicyParagraph}>
          Tienes derecho a acceder, corregir o eliminar tu información personal que mantenemos. También puedes oponerte al procesamiento de tus datos personales en ciertas circunstancias. Para ejercer estos derechos, ponte en contacto con nosotros a través de <strong>info@bonfertech.com</strong>.
        </p>
        
        <h2 className={styles.privacyPolicySubTitle}>7. Cambios en esta Política de Privacidad</h2>
        <p className={styles.privacyPolicyParagraph}>
          Podemos actualizar esta política de privacidad periódicamente. Publicaremos cualquier cambio en esta página, y si los cambios son significativos, te lo notificaremos por otros medios.
        </p>
        
        <h2 className={styles.privacyPolicySubTitle}>8. Contacto</h2>
        <p className={styles.privacyPolicyParagraph}>
          Si tienes preguntas o inquietudes sobre esta política de privacidad o sobre cómo manejamos tu información, puedes contactarnos en:
        </p>
        <p className={styles.privacyPolicyParagraph}>
          <strong>BonFer Tech S.L</strong><br />
          Correo electrónico: <a href="mailto:info@bonfertech.com" className={styles.emailLink}>info@bonfertech.com</a>
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
